import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import axios from "axios";
import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import AddFirma from "./AddFirms";
import { getToken, base_url } from "../../config/config";
// Import the AddFirma component

const FirmaTable = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false); // State to control the modal

  useEffect(() => {
    // Fetch data from the API
    axios
      .get(`${base_url}/v1/getFirma`)
      .then((response) => {
        if (response.data && response.data.data) {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  // Define columns for the table
  const columns = [
    // {
    //   accessorKey: '_id',
    //   header: 'ID',
    // },
    {
      accessorKey: "konto",
      header: "konto",
    },
    {
      accessorKey: "bezeichnung",
      header: "bezeichnung",
    },
    {
      accessorKey: "kurzbezeichnung",
      header: "kurzbezeichnung",
    },
    {
      accessorKey: "ustIdNummer",
      header: "ustIdNummer",
      Cell: ({ cell }) =>
        cell.getValue() ||
        cell.row.original.ustIdNumber ||
        cell.row.original.ustIdNummer ||
        cell.row.original.ustIdNumber, // Handle different property names
    },
  ];

  // Handler to open and close the modal
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        onClick={handleOpen}
        style={{ marginBottom: "20px" }}>
        Add New Firma
      </Button>

      <MaterialReactTable
        columns={columns}
        data={data}
        enableRowSelection={false}
        enableSorting={true}
        initialState={{ showColumnFilters: true }}
      />

      {/* Dialog for Add Firma */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='sm'>
        <DialogTitle>Add New Firma</DialogTitle>
        <DialogContent>
          <AddFirma />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FirmaTable;
